import React from 'react';
import { Outlet, useLocation, useParams } from 'react-router';
import { Footer, HeaderBar, Page, Suspense } from '@axiom/ui';

import { AuthenticatedHeaderMenu } from '../AuthenticatedHeaderMenu/AuthenticatedHeaderMenu';
import { SubNavigationHeader } from '../SubNavigationHeader/SubNavigationHeader';
import { EnvUtil } from '../../utils/env-util';

export const PageLayout = () => {
  const { accountId } = useParams();
  const location = useLocation();
  const hideNavigation = location.pathname.includes('intake');

  return (
    <Page
      name="PageLayout"
      Header={
        <>
          <HeaderBar
            name="TOPNAV"
            logoUrl={`/account/${accountId ?? ''}`}
            hideNavigation={hideNavigation}
          >
            <AuthenticatedHeaderMenu
              name="AUTHENTICATED_HEADER_MENU"
              hideNavigation={hideNavigation}
            />
          </HeaderBar>
          {!hideNavigation && (
            <SubNavigationHeader name="SUB_NAVIGATION_HEADER" />
          )}
        </>
      }
      Footer={<Footer cookieProId={EnvUtil.cookieProId} />}
    >
      <Suspense>
        <Outlet />
      </Suspense>
    </Page>
  );
};
